import React from "react";
import { Bell, ArrowUp, ArrowDown } from "@phosphor-icons/react";

export default function AlertsPanel({ alerts = [] }) {
  return (
    <div className="bg-surface border border-white/10 p-5" data-testid="alerts-panel">
      <div className="flex items-center gap-2 mb-3">
        <Bell size={16} weight="fill" />
        <h3 className="heading text-lg font-semibold">Alerts</h3>
        <span className="overline ml-auto">{alerts.length}</span>
      </div>
      {alerts.length === 0 ? (
        <div className="overline text-center py-6">no alerts triggered</div>
      ) : (
        <div className="space-y-1.5 max-h-72 overflow-y-auto">
          {alerts.map((a, i) => {
            const c = a.direction === "up" ? "#34C759" : "#FF3B30";
            const Icon = a.direction === "up" ? ArrowUp : ArrowDown;
            return (
              <div key={i} className="border border-white/5 px-3 py-2" data-testid={`alert-item-${i}`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Icon size={14} weight="bold" color={c} />
                    <span className="mono text-xs">{a.label}</span>
                  </div>
                  <span className="mono text-[10px] text-white/40">{a.time}</span>
                </div>
                <div className="mono text-[11px] text-white/60 mt-1">{a.msg}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
